import { render, staticRenderFns } from "./PublicationTopic.vue?vue&type=template&id=9665d280&scoped=true"
import script from "./PublicationTopic.vue?vue&type=script&lang=js"
export * from "./PublicationTopic.vue?vue&type=script&lang=js"
import style0 from "./PublicationTopic.vue?vue&type=style&index=0&id=9665d280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9665d280",
  null
  
)

export default component.exports